import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        isLoggedIn: false,
        initials: '',
        image: ''
    }),
    actions: {
        login(user) {
            this.initials = user.initials;
            this.image = user.image;
            this.isLoggedIn = true;
        },
        logout() {
            this.isLoggedIn = false;
            this.initials = '';
            this.image = '';

            //If we're doing event registration, refresh the iframe
            let iframe = document.querySelector('body.event-registration #event-registration-frame');

            if (iframe) {
                iframe.src = iframe.dataset.src;
            }
        },
        checkAuth() {
            return this.isLoggedIn;
        },
    },
    persist: {
        storage: sessionStorage
    }
});
